import axios from "../../axios/axios";

/**
 * Upload an image file by converting to base64 and sending to API
 * Expects backend endpoint at: POST {baseURL}/upload-image
 * Body: { image: string(base64 data URL), fileName: string }
 * Returns: response.data (e.g., { url: string, ... })
 */
export const uploadImageApi = async (file) => {
  try {
    const formData = new FormData();
    formData.append("image", file);
    formData.append("fileName", file?.name || "image");

    const response = await axios.post("uploads", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
